module.exports = __webpack_public_path__ + "img/atok_import_002.fc08d1db.png";